import { useInvalidateBusinessAreaQueries } from '@/modules/BusinessAreas/hooks/use-invalidate-business-areas-queries';
import { useCreateBusinessArea } from '@/modules/BusinessAreas/queries/create-businessArea';
import { BusinessAreaSchemaType } from '@/modules/BusinessAreas/types/businessArea-schema';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { BusinessAreaModal } from '../BusinessAreaModal';

interface CreateBusinessAreaModal {
  isOpen: boolean;
  handleClose: () => void;
  companyId?: number;
  disableFields?: string[];
  organizationId?: number;
  onSubmit?: () => void;
}

export const CreateBusinessAreaModal = ({
  isOpen,
  handleClose,
  companyId,
  disableFields,
  organizationId,
  onSubmit,
}: CreateBusinessAreaModal): ReactElement => {
  const { t } = useTranslation();
  const invalidateQueries = useInvalidateBusinessAreaQueries();

  const { mutate, isLoading } = useCreateBusinessArea();

  const handleConfirm = (data: BusinessAreaSchemaType) => {
    const convertedData = {
      id: data.id ?? 0,
      companyId: Number(data.companyId),
      name: data.businessAreaName,
      code: data.businessAreaCode,
      status: true,
      parentBusinessAreaId: data.parentBusinessAreaId,
    };

    mutate(convertedData, {
      onError: () => {
        toast.error(t('error_creating_businessArea'));
      },
      onSuccess: () => {
        invalidateQueries();
        handleClose();
        toast.success(t('success_creating_businessArea'));
        onSubmit && onSubmit();
      },
    });
  };

  return (
    <BusinessAreaModal
      handleClose={handleClose}
      type="create"
      handleOnSubmit={handleConfirm}
      isOpen={isOpen}
      isLoading={isLoading}
      title={t('create_business_area')}
      companyId={companyId}
      organizationId={organizationId}
      disableFields={disableFields}
    />
  );
};
